var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.004 7.17A2.826 2.826 0 0 0 8.174 10a2.826 2.826 0 0 0 2.83 2.83 2.826 2.826 0 0 0 2.83-2.83 2.826 2.826 0 0 0-2.83-2.83ZM6.674 10a4.326 4.326 0 0 1 4.33-4.33 4.326 4.326 0 0 1 4.33 4.33 4.326 4.326 0 0 1-4.33 4.33A4.326 4.326 0 0 1 6.674 10Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.261 6.997C3.652 3.239 7.156.97 11.004.97c3.848 0 7.352 2.269 9.743 6.027.544.855.792 1.95.792 2.998 0 1.049-.248 2.143-.792 2.998-2.391 3.758-5.895 6.027-9.743 6.027-3.848 0-7.352-2.269-9.743-6.027-.545-.855-.792-1.95-.792-2.998 0-1.049.247-2.144.792-2.998Zm9.743-4.527c-3.212 0-6.288 1.891-8.477 5.333h-.001c-.355.556-.557 1.351-.557 2.192 0 .84.202 1.636.557 2.192 2.19 3.442 5.266 5.333 8.478 5.333 3.212 0 6.288-1.891 8.477-5.332v-.002c.355-.555.558-1.35.558-2.191 0-.84-.203-1.636-.557-2.191l-.001-.001C17.29 4.36 14.216 2.47 11.004 2.47Z",
    fill: "#123862"
  })));
};
export default SvgEye;